export default {
  data() {
    return {
      tabArr: [{ tabName: '全部供应商' }, { tabName: '收藏供应商' }],
      creditArr: [
        {
          value: '',
          label: '全部等级',
        },
        {
          value: 'AAA+',
          label: 'AAA+',
        },
        {
          value: 'AAA',
          label: 'AAA',
        },
        {
          value: 'AA+',
          label: 'AA+',
        },
        {
          value: 'AA',
          label: 'AA',
        },
        {
          value: 'AA-',
          label: 'AA-',
        },
        {
          value: 'A+',
          label: 'A+',
        },
        {
          value: 'A',
          label: 'A',
        },
        {
          value: 'A-',
          label: 'A-',
        },
        {
          value: 'BBB+',
          label: 'BBB+',
        },
        {
          value: 'BBB',
          label: 'BBB',
        },
        {
          value: 'BBB-',
          label: 'BBB-',
        },
        {
          value: 'BB+',
          label: 'BB+',
        },
        {
          value: 'BB',
          label: 'BB',
        },
        {
          value: 'BB-',
          label: 'BB-',
        },
        {
          value: 'B+',
          label: 'B+',
        },
        {
          value: 'B',
          label: 'B',
        },
        {
          value: 'B-',
          label: 'B-',
        },
        {
          value: 'CCC+',
          label: 'CCC+',
        },
        {
          value: 'CCC',
          label: 'CCC',
        },
        {
          value: 'CCC-',
          label: 'CCC-',
        },
        {
          value: 'CC+',
          label: 'CC+',
        },
        {
          value: 'CC',
          label: 'CC',
        },
        {
          value: 'CC-',
          label: 'CC-',
        },
        {
          value: 'C+',
          label: 'C+',
        },
        {
          value: 'C',
          label: 'C',
        },
        {
          value: 'C-',
          label: 'C-',
        },
      ],
      leftTableLabel: [
        {
          label: '供应商名称',
          param: 'companyName',
          align: 'center',
          minWidth: 200,
        },
        {
          label: '易派客标准指数',
          param: 'scoreAll',
          align: 'center',
          minWidth: 120,
        },
        {
          label: '产品质量评价',
          align: 'center',
          minWidth: 120,
          slot: 'scoreAll',
        },
        {
          label: '法人信用认证',
          align: 'center',
          param: 'creditGrade',
          minWidth: 120,
        },
        {
          label: '履约动态考评',
          align: 'center',
          width: 160,
          slot: 'compliance',
        },
        {
          label: '市场业绩表现',
          align: 'center',
          minWidth: 120,
          slot: 'innovationEvaluate',
        },
      ],
      rightTableLabel: [
        {
          label: '已选供应商',
          param: 'companyName',
          align: 'center',
          minWidth: 200,
        },
      ],
      detailTableLabel: [
        {
          label: '商品类目',
          param: 'categoryDescription',
          align: 'center',
          minWidth: 200,
        },
        {
          label: '产品质量评价分数',
          param: 'productEvaluate',
          align: 'center',
          minWidth: 200,
        },
      ],
    };
  },
};
